import { DashboardsProvider } from './context';
import { DashboardsView } from './dashboards-view.component';

export const Dashboards = () => (
  <DashboardsProvider>
    <DashboardsView />
  </DashboardsProvider>
);
